import { useState } from 'react';

export interface TabItem {
  value: string;
  label: string;
  count?: number;
}

export interface TabsProps {
  items: TabItem[];
  /** Controlled selection. Pair with `onChange`. */
  value?: string;
  onChange?: (value: string) => void;
  /** Uncontrolled initial selection. */
  defaultValue?: string;
  variant?: 'pill';
  className?: string;
}

export function Tabs({ items, value, onChange, defaultValue, className = '' }: TabsProps) {
  const [internal, setInternal] = useState(defaultValue ?? items[0]?.value);
  const active = value ?? internal;
  const select = (v: string) => {
    if (value === undefined) setInternal(v);
    onChange?.(v);
  };
  return (
    <div className={`tr-tabs ${className}`.trim()} role="tablist">
      {items.map((t) => (
        <button
          key={t.value}
          role="tab"
          aria-selected={active === t.value}
          className={`tr-tab ${active === t.value ? 'is-active' : ''}`.trim()}
          onClick={() => select(t.value)}
        >
          {t.label}
          {t.count != null && <span className="tr-tab__count">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
